import { useLocation } from "react-router-dom";

export const matchesNavigationPath = (currentPath, targetPath) => {
  const normalizedCurrent = String(currentPath || "").toLowerCase();
  const normalizedTarget = String(targetPath || "").toLowerCase();

  if (!normalizedTarget) return false;
  if (normalizedTarget === "/") return normalizedCurrent === normalizedTarget;

  return (
    normalizedCurrent === normalizedTarget ||
    normalizedCurrent.startsWith(`${normalizedTarget}/`)
  );
};

export const useNavigation = () => {
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();

  const isItemDirectlyActive = (item) => {
    const linkPath = item.link || "";
    const activeMatches = Array.isArray(item.activeMatch)
      ? item.activeMatch.map((path) => String(path || ""))
      : [];

    return (
      matchesNavigationPath(currentPath, linkPath) ||
      activeMatches.some((path) => matchesNavigationPath(currentPath, path))
    );
  };

  const hasActiveDescendant = (item) =>
    Boolean(
      item.subItems?.some(
        (child) => isItemDirectlyActive(child) || hasActiveDescendant(child),
      ),
    );

  const getItemActiveState = (item) => {
    const isDirectlyActive = isItemDirectlyActive(item);
    const isDescendantActive = hasActiveDescendant(item);

    return {
      isDirectlyActive,
      isDescendantActive,
      isActive: isDirectlyActive || isDescendantActive,
      isCurrentPage: isDirectlyActive && !isDescendantActive,
    };
  };

  const isItemActive = (item) => {
    return getItemActiveState(item).isActive;
  };

  return {
    currentPath,
    getItemActiveState,
    isItemActive,
  };
};
